import { render } from "./ResetPasswordGuestView.vue?vue&type=template&id=33a07ae9&ts=true"
import script from "./ResetPasswordGuestView.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordGuestView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__